import React from 'react';
import { Container, Wrapper, Content, ContentContainer, ContentFill, DevSection } from './DevelopmentContent.style.pn';

interface DevelopmentContentProps {
  bg: string;
  fillBg?: string;
  children: React.ReactNode;
}

interface DevelopmentSectionProps {
  bg?: string;
  narrow?: boolean;
  children: React.ReactNode;
}

export const DevelopmentSection: React.FC<DevelopmentSectionProps> = ({ bg, narrow, children }) => {
  return (
    <DevSection $bg={bg}>
      <Content $narrow={narrow}>{children}</Content>
    </DevSection>
  );
};

const DevelopmentContent: React.FC<DevelopmentContentProps> = ({ bg, fillBg, children }) => {
  return (
    <Container data-testid="pn-development-content" $bg={bg}>
      <Wrapper>
        <ContentContainer>
          <ContentFill $fillBg={fillBg}>{children}</ContentFill>
        </ContentContainer>
      </Wrapper>
    </Container>
  );
};

export default DevelopmentContent;
